/* import __COLOCATED_TEMPLATE__ from './lsg-radio.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';

export default Component.extend({
  /**
   * @inheritDoc
   */
  classNames: ['LSG-c-radio'],

  /**
   * The radio button group name.  These should be the same for each radio group.
   *
   * @param {String}
   */
  groupName: '',

  /**
   * The title of the label for the radio button
   *
   * @param {String}
   */
  title: '',

  /**
   * Whether to skip sanitization of `title`
   *
   * @param {Boolean=}   Optional
   */
   isTitleSafe: false,

  /**
   * The value of this radio button.
   *
   * @param {String}
   */
  value: null,

  /**
   * The inputId or we'll generate a unique one.
   *
   * @param {String=}   Optional
   */
  inputId: computed(function() {
    return 'lsg-radio' + this.get('elementId');
  }),

  /**
   * If you'd like to disable the input
   *
   * @param {Boolean=}  Optional
   */
  isDisabled: false,

  /**
   * Set this input to checked by default
   *
   * @param {Boolean=}   Optional
   */
  isChecked: false,

  /**
   * Called when the user clicks the radio button.  Will send the value.
   *
   * @param {Function=}   Optional
   */
  radioClicked: function() {},

  actions: {
    /**
     * Called when the radio item element was clicked on.
     *
     * @private
     */
    _radioItemClicked: function() {
      this.get('radioClicked')(this.get('value'));
    },
  }
});
